import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { AuthSessionService } from './core/services/auth-session.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [FormsModule, RouterOutlet, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  readonly authSessionService = inject(AuthSessionService);
  reauthenticationEmail = '';
  reauthenticationPassword = '';
  reauthenticationCode = '';

  submitReauthenticationCredentials(): void {
    void this.authSessionService.submitReauthenticationCredentials(
      this.reauthenticationEmail.trim(),
      this.reauthenticationPassword,
    );
  }

  submitReauthenticationTwoFactor(): void {
    void this.authSessionService.submitReauthenticationTwoFactor(this.reauthenticationCode.trim());
  }

  cancelReauthentication(): void {
    this.reauthenticationPassword = '';
    this.reauthenticationCode = '';
    this.authSessionService.cancelReauthentication();
  }
}
